import React, { useState, useCallback, useEffect } from "react";
import { useBreakpointValue } from "@chakra-ui/react";
import logo from "../Assets/Images/ncs-logo.svg";
import { setloadTost } from "../redux/slices/toastSlice";
import { useDispatch } from "react-redux";
import { removeUser } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import CorporateOrgForm from "../components/CorporateOrgForm";
import CorporateOwnerForm from "../components/CorporateOwnerForm";
import CorporateNcsMemberForm from "../components/CorporateNcsMemberForm";
import CorporateSponsorForm from "../components/CorporateSponsorForm";
import CorporateUploadDocForm from "../components/CorporateUploadDocForm";
import { createCorporateApplicationForm, editCorporateApplicationForm, fetchCorporateApplication } from "../redux/slices/corporateRegistrationSlice";
import { generateCorporateFormData } from "../components/generateCorporateFormData";
import CorporateApplicationFormHeaderNew from "../components/CorporateApplicationFormHeaderNew";

const CorporateApplicationFormNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [saveloading, setSaveloading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [approved, setApproved] = useState(false);
  const [formSave, setFormSave] = useState(false);
  const [noData, setNoData] = useState(false);
  const [declined, setDeclined] = useState(false);
  const [comment, setComment] = useState("");
  const errorsArray = Array.isArray(error) ? error : [error];
  let updatedFormDatas;
  let updatedFormDatasave;
  let updatedFormDatasubmit;
  const [formData, setFormData] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const signOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("persist:root");
    navigate("/");
  };

  const getRegisteredCorporate = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchCorporateApplication());
      if (response?.payload?.data?.isSuccess === true) {
        if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Pending"
        ) {
          setLoading(false);
          setSubmitted(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Approved"
        ) {
          setLoading(false);
          setApproved(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Declined"
        ) {
          setLoading(false);
          setDeclined(true);
          setComment(response?.payload?.data?.comment);
        } else if (response?.payload?.data?.isSubmitted === false) {
          setLoading(false);
          setFormSave(true);
        }
      } else {
        if (response?.payload?.response?.status === 404) {
          setLoading(false);
          setNoData(true);
        } else if (response?.payload?.response?.status === 401) {
          dispatch(removeUser());
          localStorage.removeItem("persist:root");
          navigate("/");
        } else {
          setLoading(false);
          setError(
            response?.payload?.response?.data?.errors?.map(
              (errors) => errors
            ) ||
              response?.payload?.response?.data?.error?.description ||
              "Failed to get Applicaion Form, please check your request/network"
          );
        }
      }
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get Application Form, please check your request/network"
      );
    } finally {
      setLoading(false);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    getRegisteredCorporate();
  }, [getRegisteredCorporate]);

  const handleNext = (data) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...data,
    }));

    if (activeStep < max) {
      setActiveStep(activeStep + 1);
    }
  };
  const handlePrevious = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const handleCancel = () => {};

  const handleSubmit = async (data) => {
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        ...data,
      };
      return (updatedFormDatas = updatedFormData);
    });
    if (updatedFormDatas) {
      try {
        const CoporateFormData = await generateCorporateFormData(updatedFormDatas, true);
        setLoading(true);
        setError("");
        const response = await dispatch(
          createCorporateApplicationForm(CoporateFormData)
        );
        if (response?.payload?.isSuccess === true) {
          setLoading(false);
          setError("");
          dispatch(
            setloadTost({
              title: "Application Submitted",
              description: "Corporate Application submitted successfully",
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top",
            })
          );
          navigate("/");
        } else {
          setLoading(false);
          setError(
            response?.payload?.errors?.map((errors) => errors) ||
              response?.payload?.error?.description ||
              "Failed to create student application"
          );
        }
      } catch (error) {
        setError(
          error?.payload?.message ||
            "Failed to create student application, please check your network"
        );
      } finally {
        setLoading(false);
      }
    }
  };
  const handleSaveRegLater = async (data) => {
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        ...data,
      };
      return (updatedFormDatasave = updatedFormData);
    });
    if (updatedFormDatasave) {
      try {
        const CoporateFormData = await generateCorporateFormData(
          updatedFormDatasave,
          false
        );
        setSaveloading(true);
        setError("");
        const response = await dispatch(
          createCorporateApplicationForm(CoporateFormData)
        );
        if (response?.payload?.isSuccess === true) {
          setSaveloading(false);
          setError("");
          dispatch(
            setloadTost({
              title: "Application Saved",
              description: "Student Application saved successfully",
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top",
            })
          );
        } else {
          setSaveloading(false);
          setError(
            response?.payload?.errors?.map((errors) => errors) ||
              response?.payload?.error?.description ||
              "Failed to create Student application"
          );
        }
      } catch (error) {
        setError(
          error?.payload?.message ||
            "Failed to save application, please check your network"
        );
      } finally {
        setSaveloading(false);
      }
    }
  };

  const handleEdit = async (data) => {
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        ...data,
      };
      return (updatedFormDatasubmit = updatedFormData);
    });
    if (updatedFormDatasubmit) {
      try {
        const CoporateFormData = await generateCorporateFormData(
          updatedFormDatasubmit,
          true
        );
        setLoading(true);
        setError("");
        const response = await dispatch(editCorporateApplicationForm(CoporateFormData));
        if (response?.payload?.isSuccess === true) {
          setLoading(false);
          setError("");
          dispatch(
            setloadTost({
              title: "Application Submitted",
              description: "Student Application submitted successfully",
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top",
            })
          );
          navigate("/");
        } else {
          setLoading(false);
          setError(
            response?.payload?.errors?.map((errors) => errors) ||
              response?.payload?.error?.description ||
              "Failed to create student application"
          );
        }
      } catch (error) {
        setError(
          error?.payload?.message ||
            "Failed to create student application, please check your network"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const steps = [
    {
      title: "Organization Details",
      form: (
        <CorporateOrgForm handleNext={handleNext} handleCancel={handleCancel} />
      ),
    },
    {
      title: "Names & Addresses of Principal Directors, Partners, and Owners",
      form: (
        <CorporateOwnerForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    {
      title:
        "Information on Two Designated Officers/Directors Who Are NCS Members",
      form: (
        <CorporateNcsMemberForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    {
      title: "Sponsors",
      form: (
        <CorporateSponsorForm
          handleSaveRegLater={handleSaveRegLater}
          handleSubmit={handleSubmit}
          handleEdit={handleEdit}
          loading={loading}
          saveloading={saveloading}
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    {
      title: "Documents Upload",
      form: (
        <CorporateUploadDocForm
          handleSaveRegLater={handleSaveRegLater}
          handleSubmit={handleSubmit}
          handleEdit={handleEdit}
          loading={loading}
          saveloading={saveloading}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
  ];
  const max = steps.length - 1;
  const progressPercent = (activeStep / max) * 100;
  const orientation = useBreakpointValue({
    base: "vertical",
    md: "vertical",
    lg: "vertical",
  });
  const appData = {
    logo,
    signOut,
    error,
    errorsArray,
    steps,
    activeStep,
    setActiveStep,
    progressPercent,
    orientation,
    submitted,
    formSave,
    noData,
    formData,
    approved,
    declined,
    comment,
  };

  return <CorporateApplicationFormHeaderNew {...appData} />;
};

export default CorporateApplicationFormNew;
